import * as React from 'react';
import { Button } from '../../../components/Button/Button';
import { LinkClass } from '../../../components/Link';
import { getQueryParams } from '../../../helpers/IsomorphicHelpers';
import { __ } from '../../../helpers/TranslationService';
import { IRouterReducer } from '../../../reducers/router';

interface IProps {
    url: string;
    disabled?: boolean;
    getStepValidity?: () => boolean;
    router: IRouterReducer;
}

export function RequestFormBtn({ url, disabled, getStepValidity, router }: IProps) {
    const { promotionCode } = getQueryParams();

    const promotionCodeString = promotionCode ? '?promotionCode=' + promotionCode : '';
    let target = `${url}${promotionCodeString}`;

    if (router.localizationSlug) {
        target = `/${router.localizationSlug}${target}`;
    }

    const handleClick = () => {
        const isValid = getStepValidity();

        if (!isValid) {
            return;
        }

        // we only use this component on mobile.
        // code adapted from `Link` component click function
        // because there is no way to tap into Link onClick
        const relativeHref = LinkClass.getRelativeHref(target, window.location);

        if (!relativeHref) {
            return;
        }

        router.history.push(relativeHref);
    };

    return (
        <Button
            fullWidth
            withArrow
            disabled={disabled}
            onClick={handleClick}
            testSelectorName="submitRequest"
        >
            {__('continue', 'dreamlines')}
        </Button>
    );
}
